export default __webpack_public_path__ + "static/opengraph-748ebef367a75d9b8d333c760b348172.jpg";